module.exports = __webpack_public_path__ + "img/radio.edbae6c0.png";